var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 272.974,
    height: 59.74,
    viewBox: "0 0 272.974 59.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_color",
    transform: "translate(-120.088 -126.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_40",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 40",
    transform: "translate(120.088 126.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_9",
    "data-name": "\\u30D1\\u30B9 9",
    d: "M137.346,186.738H133.11a13.037,13.037,0,0,1-13.022-13.022v-33.7A13.036,13.036,0,0,1,133.11,127h4.235a2.93,2.93,0,1,1,0,5.861H133.11a7.168,7.168,0,0,0-7.161,7.16v33.7a7.169,7.169,0,0,0,7.161,7.161h4.235a2.93,2.93,0,0,1,0,5.861Z",
    transform: "translate(-120.088 -126.998)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_10",
    "data-name": "\\u30D1\\u30B9 10",
    d: "M153.895,186.738h-4.237a13.036,13.036,0,0,1-13.021-13.022v-33.7A13.035,13.035,0,0,1,149.658,127h12.379a13.036,13.036,0,0,1,13.022,13.021v17.918a2.93,2.93,0,1,1-5.861,0V140.019a7.168,7.168,0,0,0-7.161-7.16H149.658a7.167,7.167,0,0,0-7.16,7.16v33.7a7.168,7.168,0,0,0,7.16,7.161h4.237a2.93,2.93,0,1,1,0,5.861Z",
    transform: "translate(-116.696 -126.998)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11",
    "data-name": "\\u30D1\\u30B9 11",
    d: "M174.933,182.849a11.287,11.287,0,0,1-11.274-11.274V148.9a2.931,2.931,0,0,1,5.861,0v22.672a5.413,5.413,0,0,0,10.827,0V148.9a2.93,2.93,0,0,1,5.861,0v22.672A11.287,11.287,0,0,1,174.933,182.849Z",
    transform: "translate(-111.157 -123.109)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_12",
    "data-name": "\\u30D1\\u30B9 12",
    d: "M159.519,150.9h-2.442a2.608,2.608,0,0,1,0-5.216h2.442a2.608,2.608,0,0,1,0,5.216Z",
    transform: "translate(-113.041 -123.168)",
    fill: "#0071b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_44",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 44",
    transform: "translate(220.583 130.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13",
    "data-name": "\\u30D1\\u30B9 13",
    d: "M293.193,175.431l5.313-19.172V145.243a3.615,3.615,0,0,0-3.615-3.615h-3.515a1.2,1.2,0,0,0-1.2,1.2v12.292l-5.938,21.429a1.206,1.206,0,0,0,1.162,1.527h4.315A3.615,3.615,0,0,0,293.193,175.431Z",
    transform: "translate(-186.947 -127.876)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_41",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 41",
    transform: "translate(43.167 1.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_48",
    "data-name": "\\u9577\\u65B9\\u5F62 48",
    d: "M3,0H31.685a1,1,0,0,1,1,1V5.841a3,3,0,0,1-3,3H1a1,1,0,0,1-1-1V3A3,3,0,0,1,3,0Z",
    transform: "translate(2.147)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_49",
    "data-name": "\\u9577\\u65B9\\u5F62 49",
    d: "M3,0H35.978a1,1,0,0,1,1,1V5.841a3,3,0,0,1-3,3H1a1,1,0,0,1-1-1V3A3,3,0,0,1,3,0Z",
    transform: "translate(0 14.941)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_14",
    "data-name": "\\u30D1\\u30B9 14",
    d: "M271.048,178.253h-11.47a12.049,12.049,0,0,1-12.048-12.05V132.835h8.335V166.2a3.714,3.714,0,0,0,3.714,3.714h8.647a4.236,4.236,0,0,1,4.235,4.235v2.688A1.413,1.413,0,0,1,271.048,178.253Z",
    transform: "translate(-237.628 -130.941)",
    fill: "#0071b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_42",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 42",
    transform: "translate(138.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_50",
    "data-name": "\\u9577\\u65B9\\u5F62 50",
    d: "M3,0H31.452a3,3,0,0,1,3,3V6.841a2,2,0,0,1-2,2H1a1,1,0,0,1-1-1V3A3,3,0,0,1,3,0Z",
    transform: "translate(0 7.351)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_15",
    "data-name": "\\u30D1\\u30B9 15",
    d: "M328.026,177.77l5.313-19.172V133.83a3.615,3.615,0,0,0-3.615-3.615h-3.515a1.205,1.205,0,0,0-1.2,1.2v26.044l-5.938,21.429a1.205,1.205,0,0,0,1.162,1.527h4.315A3.614,3.614,0,0,0,328.026,177.77Z",
    transform: "translate(-317.834 -130.215)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_16",
    "data-name": "\\u30D1\\u30B9 16",
    d: "M337.3,178.125a1.412,1.412,0,0,1-2.006-1.277l-.011-4.69a2.542,2.542,0,0,1,1.76-2.427l2.451-1.607c.942-.518,1.123-2.355,1.123-5.044v-21.8h8.336v21.8c0,7.6-3.386,11.973-8.377,13.522Z",
    transform: "translate(-314.501 -127.947)",
    fill: "#0071b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_43",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_17",
    "data-name": "\\u30D1\\u30B9 17",
    d: "M233.227,150.989l-27.96-7.526a1.411,1.411,0,0,0-1.779,1.363V148.4a4.236,4.236,0,0,0,3.135,4.09L234.582,160a1.412,1.412,0,0,0,1.779-1.364v-3.558A4.235,4.235,0,0,0,233.227,150.989Z",
    transform: "translate(-203.488 -127.51)",
    fill: "#0071b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_18",
    "data-name": "\\u30D1\\u30B9 18",
    d: "M218.1,133.943l-2.092,17.383-11.563,27.129a1.411,1.411,0,0,0,1.3,1.965h4.128a4.236,4.236,0,0,0,3.9-2.574L224.142,153.5l2.614-21.708a1.412,1.412,0,0,0-1.4-1.58h-3.049A4.234,4.234,0,0,0,218.1,133.943Z",
    transform: "translate(-203.315 -130.215)",
    fill: "#0071b9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_19",
    "data-name": "\\u30D1\\u30B9 19",
    d: "M306.087,131.263h0Z",
    transform: "translate(-183.103 -130)",
    fill: "#75b900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20",
    "data-name": "\\u30D1\\u30B9 20",
    d: "M311.062,131.263H282.908a4.235,4.235,0,0,0-4.234,4.235v3.194a1.411,1.411,0,0,0,1.411,1.411h25.776l-1.688,9.087a1.412,1.412,0,0,0,1.389,1.665h4.57a3.135,3.135,0,0,0,3.021-2.3l1.82-10.956h-.028l.306-1.654A4.221,4.221,0,0,0,311.062,131.263Z",
    transform: "translate(-188.077 -130)",
    fill: "#0071b9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor);
export default __webpack_public_path__ + "static/media/logo_color.041fd20f5a76168521b8468e10f07a67.svg";
export { ForwardRef as ReactComponent };